(() => {
  const countryByHost = {
    'estarta-computer.de': { country: 'DE', language: 'de' },
    'www.estarta-computer.de': { country: 'DE', language: 'de' },
    'estarta-computer.com': { country: 'GB', language: 'en' },
    'www.estarta-computer.com': { country: 'GB', language: 'en' },
    'estarta.fr': { country: 'FR', language: 'fr' },
    'www.estarta.fr': { country: 'FR', language: 'fr' },
  };

  const setValue = (form, name, value) => {
    let input = form.querySelector(`input[name="${name}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  };

  const submitMarket = (form, country, language) => {
    setValue(form, 'form_type', 'localization');
    setValue(form, 'utf8', '✓');
    setValue(form, '_method', 'put');
    setValue(form, 'return_to', window.location.pathname + window.location.search);
    setValue(form, 'country_code', country);
    setValue(form, 'language_code', language);
    form.submit();
  };

  const initialize = () => {
    const switcher = document.querySelector('.estarta-market-switcher');
    if (!switcher) return;

    for (const button of switcher.querySelectorAll('[data-estarta-market-button]')) {
      button.addEventListener('click', () => {
        const form = button.closest('form');
        if (!form) return;
        submitMarket(form, button.dataset.country, button.dataset.language);
      });
    }

    const expected = countryByHost[window.location.hostname.toLowerCase()];
    if (!expected || switcher.dataset.currentCountry === expected.country) return;

    const guardKey = `estarta-market-fix:${window.location.hostname}:${window.location.pathname}`;
    if (window.sessionStorage.getItem(guardKey) === expected.country) return;

    const form = switcher.querySelector(`[data-country="${expected.country}"]`)?.closest('form');
    if (!form) return;

    window.sessionStorage.setItem(guardKey, expected.country);
    submitMarket(form, expected.country, expected.language);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();